// Arabic strings for the registry area (property & location registry, room kits, location tags). Keyed by the English source text; {name} placeholders stay as-is.
export default {
  ' and {n} new Location Type(s)': ' و{n} نوع موقع جديد',
  ' on {n} new floor(s)': ' في {n} طابق جديد',
  ' to {n} Room': ' على {n} غرفة',
  ' to {n} Rooms': ' على {n} غرف',
  '(an existing Location Type such as Deluxe King).': '(نوع موقع موجود مثل ديلوكس كينغ).',
  '(complete)': '(مكتملة)',
  '(in progress)': '(قيد التنفيذ)',
  ', {n} existing': '، {n} موجود',
  ', {n} new floor(s)': '، {n} طابق جديد',
  '1. Locations Created': '1. المواقع المُنشأة',
  '2. Kits Stamped': '2. المجموعات المختومة',
  '3. Tags Printed': '3. الوسوم المطبوعة',
  '4. Tags Bound': '4. الوسوم المربوطة',
  '5. First Walk Done': '5. اكتمال الجولة الأولى',
  '; type {name}': '؛ النوع {name}',
  '; {count} already had a tag': '؛ {count} لديها وسم مسبقًا',
  '; {n} kit(s) apply through its Location Types': '؛ {n} مجموعة تنطبق عبر أنواع مواقعه',
  'A Location Type is the template for similar locations, for example': 'نوع الموقع هو قالب للمواقع المتشابهة، مثل',
  'A {type} cannot be placed under a {parent}': 'لا يمكن وضع {type} تحت {parent}',
  'A4 sheet, 14 labels (2 x 7)': 'ورقة A4، ‏14 ملصقًا (2 × 7)',
  'A4 sheet, 24 labels (3 x 8)': 'ورقة A4، ‏24 ملصقًا (3 × 8)',
  'Across {wings} Wings & {floors} Floors': 'عبر {wings} أجنحة و{floors} طوابق',
  'Active Blueprints': 'المخططات النشطة',
  'Add BOM Item': 'إضافة بند إلى قائمة المواد',
  'Add Location Node': 'إضافة عقدة موقع',
  'Add Type': 'إضافة نوع',
  'Add a Building (or Wing) first; floors are generated under it.': 'أضف مبنى (أو جناحًا) أولًا؛ تُنشأ الطوابق تحته.',
  'Add a note explaining the reason': 'أضف ملاحظة توضح السبب',
  'Add to Blueprint': 'إضافة إلى المخطط',
  'Addition': 'إضافة',
  'Additions create draft assets (awaiting tag binding) or pooled par quantities.': 'تُنشئ الإضافات أصولًا مسودة (بانتظار ربط الوسم) أو كميات حد مستوى للمخزون المجمّع.',
  'Additions generate new draft asset tags for the next scan walk. Removed items are': 'تُنشئ الإضافات وسوم أصول مسودة جديدة لجولة المسح التالية. البنود المحذوفة',
  'Address': 'العنوان',
  'Affected Rooms ({n})': 'الغرف المتأثرة ({n})',
  'All locations': 'كل المواقع',
  'Allow pop-ups to view the floor plan': 'اسمح بالنوافذ المنبثقة لعرض مخطط الطابق',
  'Appliances': 'الأجهزة',
  'Apply the': 'تطبيق تغييرات',
  'Approve & Propagate': 'اعتماد ونشر',
  'Approve Kit Change': 'اعتماد تغيير المجموعة',
  'Approving creates draft assets for additions and flags removals for verification during next audit.': 'يُنشئ الاعتماد أصولًا مسودة للإضافات ويُعلِّم المحذوفات للتحقق منها في الجرد التالي.',
  'April': 'أبريل',
  'Area (m²)': 'المساحة (م²)',
  'Assets & Sub-Locations in this Node': 'الأصول والمواقع الفرعية في هذه العقدة',
  'Assign it to rooms and spaces, then attach a kit to it on the Room Kits page. Types are shared by every property of this customer.': 'عيّنه للغرف والمساحات، ثم اربط به مجموعة من صفحة مجموعات الغرف. الأنواع مشتركة بين جميع عقارات هذا العميل.',
  'Attach floor plan': 'إرفاق مخطط الطابق',
  'August': 'أغسطس',
  'Avg {n} assets per room': 'متوسط {n} أصل لكل غرفة',
  'Awaiting catalogue review': 'بانتظار مراجعة الكتالوج',
  'BOM Lines': 'بنود قائمة المواد',
  'Back of House': 'المناطق الخلفية',
  'Batch #{id} applied': 'تم تطبيق الدفعة رقم {id}',
  'Batch Import Locations': 'استيراد المواقع دفعة واحدة',
  'Batch Room Stamping Execution': 'تنفيذ ختم الغرف دفعة واحدة',
  'Batch Stamp Rooms': 'ختم الغرف دفعة واحدة',
  'Batch Stamping Complete: {n} room stamped!': 'اكتمل الختم الجماعي: تم ختم {n} غرفة!',
  'Batch Stamping Complete: {n} rooms stamped!': 'اكتمل الختم الجماعي: تم ختم {n} غرف!',
  'Bind': 'ربط',
  'Bind a printed tag or NFC sticker': 'ربط وسم مطبوع أو ملصق NFC',
  'Blueprint Name': 'اسم المخطط',
  'Blueprint to Apply': 'المخطط المراد تطبيقه',
  'Blueprint with changes': 'المخطط الذي به تغييرات',
  'Building': 'مبنى',
  'Building / Wing': 'المبنى / الجناح',
  'Category / Type': 'الفئة / النوع',
  'Change the range or the pattern before creating.': 'غيّر النطاق أو النمط قبل الإنشاء.',
  'Changes the expected quantity from {from} to {to} across {n} stamped room': 'يغيّر الكمية المتوقعة من {from} إلى {to} في {n} غرفة مختومة',
  'Changes the expected quantity from {from} to {to} across {n} stamped rooms': 'يغيّر الكمية المتوقعة من {from} إلى {to} في {n} غرف مختومة',
  'Choose CSV file...': 'اختر ملف CSV...',
  'Choose a CSV file first.': 'اختر ملف CSV أولًا.',
  'Choose a PDF or a JPEG, PNG or WebP image': 'اختر ملف PDF أو صورة JPEG أو PNG أو WebP',
  'Choose a parent node (only a Building can be a root)': 'اختر عقدة أصل (المبنى وحده يمكن أن يكون جذرًا)',
  'Choose a reason…': 'اختر سببًا…',
  'Choose a time zone from the list, for example Asia/Dubai': 'اختر منطقة زمنية من القائمة، مثل Asia/Dubai',
  'Choose the Building or Wing that holds the floors.': 'اختر المبنى أو الجناح الذي يضم الطوابق.',
  'Choose where the rooms go.': 'اختر مكان الغرف.',
  'Choose why the tag comes off': 'اختر سبب إزالة الوسم',
  'City': 'المدينة',
  'Classification': 'التصنيف',
  'Clear all': 'إلغاء تحديد الكل',
  'Clone': 'استنساخ',
  'Clone Property Structure': 'استنساخ هيكل العقار',
  'Closure': 'إغلاق',
  'Code': 'الرمز',
  'Code 128': 'Code 128',
  'Code 128 barcode': 'باركود Code 128',
  'Collapse': 'طي',
  'Collapse All': 'طي الكل',
  'Completion %': 'نسبة الإنجاز %',
  'Copy guest rooms too (untick to copy only buildings, floors and zones)': 'نسخ غرف النزلاء أيضًا (ألغِ التحديد لنسخ المباني والطوابق والمناطق فقط)',
  'Copy the room list from your PMS and paste it below: one room number per line, or': 'انسخ قائمة الغرف من نظام إدارة العقار والصقها أدناه: رقم غرفة واحد في كل سطر، أو',
  'Country': 'الدولة',
  'Create': 'إنشاء',
  'Create Blueprint': 'إنشاء المخطط',
  'Create Copy': 'إنشاء نسخة',
  'Create Location': 'إنشاء الموقع',
  'Create Location Types first (Location Types button)': 'أنشئ أنواع المواقع أولًا (زر أنواع المواقع)',
  'Create Location Types in the': 'أنشئ أنواع المواقع في',
  'Create Property': 'إنشاء عقار',
  'Create a kit blueprint (+ on the left) before adding BOM items.': 'أنشئ مخطط مجموعة (+ على اليسار) قبل إضافة بنود قائمة المواد.',
  'Create a kit blueprint first': 'أنشئ مخطط مجموعة أولًا',
  'Create a kit blueprint to define its bill of materials.': 'أنشئ مخطط مجموعة لتحديد قائمة مواده.',
  'Create missing room types as new guest-room Location Types': 'إنشاء أنواع الغرف غير الموجودة كأنواع مواقع جديدة لغرف النزلاء',
  'Created {floors} floor(s) and {rooms} room(s), {first} to {last}.': 'تم إنشاء {floors} طابق و{rooms} غرفة، من {first} إلى {last}.',
  'Created {n} room(s)': 'تم إنشاء {n} غرفة',
  'Creates a new property for this customer with the same buildings, wings, floors, zones and': 'يُنشئ عقارًا جديدًا لهذا العميل بنفس المباني والأجنحة والطوابق والمناطق و',
  'Current step:': 'الخطوة الحالية:',
  'Damaged label (tag is retired)': 'ملصق تالف (يُسحب الوسم)',
  'Date of the last renovation': 'تاريخ آخر تجديد',
  'Deactivate': 'إيقاف التفعيل',
  'Deactivate {code}': 'إيقاف تفعيل {code}',
  'December': 'ديسمبر',
  'Default Quantity': 'الكمية الافتراضية',
  'Delete Node': 'حذف العقدة',
  'Delete the Location Type {name}?': 'حذف نوع الموقع {name}؟',
  'Delete {name}': 'حذف {name}',
  'Delete {name} ({code})? This cannot be undone.': 'حذف {name} ({code})؟ لا يمكن التراجع عن ذلك.',
  'Deluxe King': 'ديلوكس كينغ',
  'Describe the building once, for example floors 3 to 15 with rooms 01 to 24 on each floor. Preview first; nothing is created until you confirm.': 'صف المبنى مرة واحدة، مثل الطوابق من 3 إلى 15 مع الغرف من 01 إلى 24 في كل طابق. اعرض المعاينة أولًا؛ لن يُنشأ شيء حتى تؤكد.',
  'Describe why the location is being taken out of use.': 'اذكر سبب إخراج الموقع من الاستخدام.',
  'Diff Type': 'نوع الفرق',
  'Different model found': 'تم العثور على طراز مختلف',
  'Done': 'تم',
  'Edit BOM Item': 'تعديل بند قائمة المواد',
  'Edit BOM item': 'تعديل بند قائمة المواد',
  'Edit Property': 'تعديل العقار',
  'Edit Property Profile': 'تعديل ملف العقار',
  'Edit {name}': 'تعديل {name}',
  'Electronics': 'الإلكترونيات',
  'Enter a blueprint name.': 'أدخل اسم المخطط.',
  'Enter a name for the Location Type, for example Deluxe King.': 'أدخل اسمًا لنوع الموقع، مثل ديلوكس كينغ.',
  'Enter a property code: letters and digits separated by hyphens, e.g. HTL-AUH-02.': 'أدخل رمز العقار: أحرف وأرقام تفصلها شرطات، مثل HTL-AUH-02.',
  'Enter a whole quantity between 1 and 100.': 'أدخل كمية صحيحة بين 1 و100.',
  'Enter the area in square metres, e.g. 32.5': 'أدخل المساحة بالمتر المربع، مثل 32.5',
  'Enter the item specification.': 'أدخل مواصفات البند.',
  'Enter the new property name.': 'أدخل اسم العقار الجديد.',
  'Enter the room type, or choose a Location Type.': 'أدخل نوع الغرفة، أو اختر نوع موقع.',
  'Enter the total room capacity (0 or more)': 'أدخل إجمالي سعة الغرف (0 أو أكثر)',
  'Enter whole numbers for the floor and room ranges.': 'أدخل أعدادًا صحيحة لنطاقي الطوابق والغرف.',
  'Errors': 'الأخطاء',
  'Every stamped room matches its blueprint. Edit a blueprint bill of materials to propose a change.': 'كل غرفة مختومة تطابق مخططها. عدّل قائمة مواد أحد المخططات لاقتراح تغيير.',
  'Exceptions resolved': 'الاستثناءات المحلولة',
  'Expand': 'توسيع',
  'Expand All': 'توسيع الكل',
  'Expected Qty': 'الكمية المتوقعة',
  'Expected Quantity per Room': 'الكمية المتوقعة لكل غرفة',
  'February': 'فبراير',
  'Filter node or room...': 'تصفية حسب العقدة أو الغرفة...',
  'First Scan Walk Status': 'حالة جولة المسح الأولى',
  'First Walk': 'الجولة الأولى',
  'First month of the property\'s financial year': 'الشهر الأول من السنة المالية للعقار',
  'Fiscal Year Starts In': 'بداية السنة المالية',
  'Fiscal year starts {month}': 'تبدأ السنة المالية في {month}',
  'Floor': 'طابق',
  'Floor / Zone': 'الطابق / المنطقة',
  'Floor area of the space': 'المساحة الأرضية للمكان',
  'Floor code pattern': 'نمط رمز الطابق',
  'Floor plan': 'مخطط الطابق',
  'Floor plan removed.': 'تمت إزالة مخطط الطابق.',
  'Floor plan {file} attached to {code}.': 'تم إرفاق مخطط الطابق {file} بـ {code}.',
  'Floors & Rooms Rule': 'قاعدة الطوابق والغرف',
  'Floors from': 'الطوابق من',
  'For example Deluxe King or Main Kitchen. Its kit can be stamped onto this location.': 'مثل ديلوكس كينغ أو المطبخ الرئيسي. يمكن ختم مجموعته على هذا الموقع.',
  'Furniture': 'الأثاث',
  'Generate Floors & Rooms': 'إنشاء الطوابق والغرف',
  'Generated {n} pending asset.': 'تم إنشاء {n} أصل معلّق.',
  'Generated {n} pending assets.': 'تم إنشاء {n} أصول معلّقة.',
  'Generates {n} new draft asset with printable ULID tags for first walk': 'يُنشئ {n} أصلًا مسودة جديدًا بوسوم ULID قابلة للطباعة للجولة الأولى',
  'Generates {n} new draft assets with printable ULID tags for first walk': 'يُنشئ {n} أصول مسودة جديدة بوسوم ULID قابلة للطباعة للجولة الأولى',
  'Guest Room': 'غرفة نزلاء',
  'Guest Rooms Registered': 'غرف النزلاء المسجلة',
  'Guest room': 'غرفة نزلاء',
  'Guest room (no type)': 'غرفة نزلاء (بلا نوع)',
  'Guest-room locations in the tree': 'مواقع غرف النزلاء في الشجرة',
  'HVAC': 'التدفئة والتهوية والتكييف',
  'Here': 'هنا',
  'Hierarchical relations are built automatically using the parent code reference.': 'تُبنى العلاقات الهرمية تلقائيًا باستخدام مرجع رمز الأصل.',
  'Hierarchy Navigation': 'التنقل الهرمي',
  'Impact on Stamped Rooms': 'الأثر على الغرف المختومة',
  'Import CSV': 'استيراد CSV',
  'Imported {n} location node(s).': 'تم استيراد {n} عقدة موقع.',
  'In Progress ({n} Rms)': 'قيد التنفيذ ({n} غرف)',
  'Inward Asset Here': 'استلام أصل هنا',
  'Item / Code': 'البند / الرمز',
  'Item Specification': 'مواصفات البند',
  'Items absent on first walk': 'بنود غائبة في الجولة الأولى',
  'January': 'يناير',
  'July': 'يوليو',
  'June': 'يونيو',
  'Kind': 'الصنف',
  'Kit': 'المجموعة',
  'Kit Blueprints': 'مخططات المجموعات',
  'Kit change approved: {n} draft asset created': 'تم اعتماد تغيير المجموعة: أُنشئ {n} أصل مسودة',
  'Kit change approved: {n} draft assets created': 'تم اعتماد تغيير المجموعة: أُنشئت {n} أصول مسودة',
  'Kit for Location Type': 'مجموعة لنوع الموقع',
  'Kit for Location Type {name}': 'مجموعة لنوع الموقع {name}',
  'Kitchen': 'مطبخ',
  'Kits Stamped': 'المجموعات المختومة',
  'Label printer, 40 x 20 mm': 'طابعة ملصقات، 40 × 20 مم',
  'Label printer, 50 x 25 mm': 'طابعة ملصقات، 50 × 25 مم',
  'Last renovated': 'آخر تجديد',
  'Laundry': 'مغسلة',
  'Leave at any step; your position is saved and resumes here.': 'يمكنك المغادرة في أي خطوة؛ يُحفظ موضعك وتستأنف من هنا.',
  'Line {n}:': 'السطر {n}:',
  'Linen': 'البياضات',
  'Linen is tracked as pooled stock, not serialized.': 'تُتتبَّع البياضات كمخزون مجمّع، لا كأصول مسلسلة.',
  'Loading rooms...': 'جارٍ تحميل الغرف...',
  'Lobbies, Kitchens, Storerooms': 'الردهات والمطابخ والمخازن',
  'Location Code': 'رمز الموقع',
  'Location Name': 'اسم الموقع',
  'Location Name / Display Label': 'اسم الموقع / التسمية المعروضة',
  'Location Tree': 'شجرة المواقع',
  'Location Type': 'نوع الموقع',
  'Location Type for the rooms': 'نوع الموقع للغرف',
  'Location Type when none is given': 'نوع الموقع عند عدم تحديده',
  'Location Types': 'أنواع المواقع',
  'Location Types and their kits are shared, so the copy is ready to stamp. Assets, tags and stamps are not copied.': 'أنواع المواقع ومجموعاتها مشتركة، لذا تكون النسخة جاهزة للختم. لا تُنسخ الأصول والوسوم والأختام.',
  'Location code is required': 'رمز الموقع مطلوب',
  'Location name is required': 'اسم الموقع مطلوب',
  'Location node details updated successfully.': 'تم تحديث تفاصيل عقدة الموقع بنجاح.',
  'Location tag': 'وسم الموقع',
  'Location {code} deleted.': 'تم حذف الموقع {code}.',
  'Locations that already have a tag are skipped.': 'يتم تخطي المواقع التي لديها وسم بالفعل.',
  'Main Kitchen': 'المطبخ الرئيسي',
  'Manage hierarchical structures, building wings, guest rooms, zones, and room stamping status': 'إدارة الهياكل الهرمية وأجنحة المباني وغرف النزلاء والمناطق وحالة ختم الغرف',
  'March': 'مارس',
  'Mark as physically stamped and audited immediately': 'تعليمه كمختوم فعليًا ومجرود فورًا',
  'Mark complete & continue to {step}': 'تعليمها مكتملة والانتقال إلى {step}',
  'Marked for removal confirmation during the next cyclic audit (zero silent deletion)': 'مُعلَّم لتأكيد الإزالة خلال الجرد الدوري التالي (بلا حذف صامت)',
  'May': 'مايو',
  'Modification': 'تعديل',
  'NFC tag': 'وسم NFC',
  'Name': 'الاسم',
  'New Kit Blueprint': 'مخطط مجموعة جديد',
  'New Property': 'عقار جديد',
  'New blueprint': 'مخطط جديد',
  'New item specification added to the blueprint BOM.': 'تمت إضافة مواصفات بند جديدة إلى قائمة مواد المخطط.',
  'New item specification added to {name} blueprint BOM.': 'تمت إضافة مواصفات بند جديدة إلى قائمة مواد المخطط {name}.',
  'New location node created and linked in the property tree.': 'تم إنشاء عقدة موقع جديدة وربطها في شجرة العقار.',
  'New property code': 'رمز العقار الجديد',
  'New property name': 'اسم العقار الجديد',
  'No Location Type': 'بلا نوع موقع',
  'No Location Types yet. Add the first one above, for example Deluxe King (guest room) or Main Kitchen (kitchen).': 'لا توجد أنواع مواقع بعد. أضف أول نوع أعلاه، مثل ديلوكس كينغ (غرفة نزلاء) أو المطبخ الرئيسي (مطبخ).',
  'No Location Types yet. Create them with the Location Types button.': 'لا توجد أنواع مواقع بعد. أنشئها بزر أنواع المواقع.',
  'No blueprints yet': 'لا توجد مخططات بعد',
  'No floor plan yet. Attach a PDF or an image (up to 5 MB) so auditors and engineers can find this space.': 'لا يوجد مخطط طابق بعد. أرفق ملف PDF أو صورة (حتى 5 ميغابايت) ليتمكن المدققون والمهندسون من إيجاد هذا المكان.',
  'No guest rooms in this property yet.': 'لا توجد غرف نزلاء في هذا العقار بعد.',
  'No kit blueprints yet. Create one to define a room bill of materials.': 'لا توجد مخططات مجموعات بعد. أنشئ مخططًا لتحديد قائمة مواد الغرفة.',
  'No kit yet': 'لا توجد مجموعة بعد',
  'No location selected': 'لم يتم تحديد موقع',
  'No locations yet. Use “Add Location Node” to create the first Building, then “Floors & Rooms Rule” or “Paste Room List” to add rooms in bulk.': 'لا توجد مواقع بعد. استخدم «إضافة عقدة موقع» لإنشاء أول مبنى، ثم «قاعدة الطوابق والغرف» أو «لصق قائمة الغرف» لإضافة الغرف دفعة واحدة.',
  'No pending kit changes': 'لا توجد تغييرات معلقة على المجموعات',
  'No property is available. Create a property in the Property & Location Registry first.': 'لا يوجد عقار متاح. أنشئ عقارًا في سجل العقارات والمواقع أولًا.',
  'No proposed changes.': 'لا توجد تغييرات مقترحة.',
  'No sub-locations or assets are registered in this node yet.': 'لا توجد مواقع فرعية أو أصول مسجلة في هذه العقدة بعد.',
  'No tag yet. Print a new labelled tag below, or bind a tag you already printed by scanning or typing its code.': 'لا يوجد وسم بعد. اطبع وسمًا جديدًا بملصق أدناه، أو اربط وسمًا مطبوعًا مسبقًا بمسحه أو كتابة رمزه.',
  'No unstamped locations here. Assign this kit\'s Location Type to locations in the registry, or choose another wing.': 'لا توجد مواقع غير مختومة هنا. عيّن نوع الموقع الخاص بهذه المجموعة لمواقع في السجل، أو اختر جناحًا آخر.',
  'None (Root Node)': 'لا شيء (عقدة جذر)',
  'None (enter a room type label below)': 'لا شيء (أدخل تسمية نوع الغرفة أدناه)',
  'None (property root — Building only)': 'لا شيء (جذر العقار — للمبنى فقط)',
  'None (room type label only)': 'لا شيء (تسمية نوع الغرفة فقط)',
  'Not Started': 'لم يبدأ',
  'Note': 'ملاحظة',
  'Note:': 'ملاحظة:',
  'Nothing has been deleted.': 'لم يُحذف أي شيء.',
  'Nothing was deleted.': 'لم يُحذف أي شيء.',
  'November': 'نوفمبر',
  'October': 'أكتوبر',
  'Office': 'مكتب',
  'Onboarding Progress': 'تقدم التهيئة',
  'Onboarding Progress by Floor / Zone': 'تقدم التهيئة حسب الطابق / المنطقة',
  'Open Kit Blueprints': 'فتح مخططات المجموعات',
  'Open {step}': 'فتح {step}',
  'Optional. Rooms of one type, e.g. Deluxe King.': 'اختياري. غرف من نوع واحد، مثل ديلوكس كينغ.',
  'Other': 'أخرى',
  'Other (add a note)': 'أخرى (أضف ملاحظة)',
  'Outlet (restaurant, bar, spa)': 'منفذ (مطعم، بار، سبا)',
  'Overall: {n}% Complete': 'الإجمالي: {n}% مكتمل',
  'Page {page} of {pages}': 'الصفحة {page} من {pages}',
  'Pantry': 'مخزن مؤن',
  'Parent Location Node': 'عقدة الموقع الأصل',
  'Parent Node': 'العقدة الأصل',
  'Paste Room List': 'لصق قائمة الغرف',
  'Paste at least one room number.': 'الصق رقم غرفة واحدًا على الأقل.',
  'Pending Diff Approval': 'فروقات بانتظار الاعتماد',
  'Pending assets': 'أصول معلّقة',
  'Place rooms under': 'وضع الغرف تحت',
  'Plant room': 'غرفة المعدات',
  'Pooled Stock': 'مخزون مجمّع',
  'Pooled par lines': 'بنود حد المخزون المجمّع',
  'Postal Code': 'الرمز البريدي',
  'Preview': 'معاينة',
  'Print Tags': 'طباعة الوسوم',
  'Print again': 'طباعة مرة أخرى',
  'Print new tag': 'طباعة وسم جديد',
  'Print on': 'الطباعة على',
  'Print tags for all {count} locations beneath': 'طباعة وسوم لكل المواقع الـ {count} التابعة',
  'Process Import': 'تنفيذ الاستيراد',
  'Property Code': 'رمز العقار',
  'Property Name': 'اسم العقار',
  'Property Onboarding Funnel Progress': 'تقدم مراحل تهيئة العقار',
  'Property code is required': 'رمز العقار مطلوب',
  'Property name is required': 'اسم العقار مطلوب',
  'Property profile updated.': 'تم تحديث ملف العقار.',
  'Property {code} created.': 'تم إنشاء العقار {code}.',
  'Proposed Changes': 'التغييرات المقترحة',
  'Proposed Diff': 'الفروقات المقترحة',
  'Proposed Version Diff': 'فروقات الإصدار المقترح',
  'Public & Support Zones': 'المناطق العامة والمساندة',
  'Public Area': 'منطقة عامة',
  'Public area': 'منطقة عامة',
  'QR code': 'رمز QR',
  'Qty Changed': 'الكمية المعدّلة',
  'Quantity Change': 'تغيّر الكمية',
  'RFID tag': 'وسم RFID',
  'Reactivate': 'إعادة التفعيل',
  'Registered equipment currently allocated to this location': 'المعدات المسجلة المخصصة حاليًا لهذا الموقع',
  'Registry': 'السجل',
  'Removal': 'إزالة',
  'Removals are only flagged for confirmation at the next audit; nothing is deleted.': 'تُعلَّم الإزالات فقط لتأكيدها في الجرد التالي؛ لا يُحذف شيء.',
  'Remove': 'إزالة',
  'Remove Item': 'إزالة البند',
  'Remove the floor plan of {code}?': 'إزالة مخطط الطابق لـ {code}؟',
  'Removed': 'المُزال',
  'Renovation': 'تجديد',
  'Replace': 'استبدال',
  'Require Serialized Asset Tag (Opaque ULID QR)': 'يتطلب وسم أصل مسلسل (رمز QR بمعرّف ULID)',
  'Result': 'النتيجة',
  'Resumed': 'مُستأنف',
  'Reviewing proposed bill-of-materials changes affecting': 'مراجعة تغييرات قائمة المواد المقترحة التي تؤثر على',
  'Room': 'الغرفة',
  'Room / Space Template': 'قالب الغرفة / المساحة',
  'Room / Space Template (Location Type)': 'قالب الغرفة / المساحة (نوع الموقع)',
  'Room Count': 'عدد الغرف',
  'Room Kit Templates, Stamping & Diff Rollout': 'قوالب مجموعات الغرف والختم ونشر الفروقات',
  'Room Stamping Status': 'حالة ختم الغرفة',
  'Room Type': 'نوع الغرفة',
  'Room code pattern': 'نمط رمز الغرفة',
  'Room has been successfully stamped.': 'تم ختم الغرفة بنجاح.',
  'Room list': 'قائمة الغرف',
  'Rooms': 'الغرف',
  'Rooms from': 'الغرف من',
  'Root': 'جذر',
  'Safe Propagation Rule:': 'قاعدة النشر الآمن:',
  'Save Changes': 'حفظ التغييرات',
  'Save Property': 'حفظ العقار',
  'Scan or type the code': 'امسح الرمز أو اكتبه',
  'Scan the tag, type the 6-character code printed under it, or tap an NFC tag': 'امسح الوسم، أو اكتب الرمز المكوّن من 6 أحرف المطبوع أسفله، أو المس وسم NFC',
  'Scanning this tag opens what the {noun} holds and starts its room audit.': 'مسح هذا الوسم يعرض محتويات {noun} ويبدأ جرد الغرفة.',
  'Scanning this tag opens what the {noun} holds.': 'مسح هذا الوسم يعرض محتويات {noun}.',
  'Select Unstamped': 'تحديد غير المختومة',
  'Select a blueprint': 'اختر مخططًا',
  'Select a blueprint on the left to see its bill of materials.': 'اختر مخططًا على اليسار لعرض قائمة مواده.',
  'Select a blueprint to apply.': 'اختر مخططًا لتطبيقه.',
  'Select a kit blueprint first': 'اختر مخطط مجموعة أولًا',
  'Select a kit blueprint on the left to add BOM items.': 'اختر مخطط مجموعة على اليسار لإضافة بنود قائمة المواد.',
  'Select a location in the tree first': 'اختر موقعًا في الشجرة أولًا',
  'Select all': 'تحديد الكل',
  'Select an unstamped guest room to stamp it': 'اختر غرفة نزلاء غير مختومة لختمها',
  'Select at least one room to stamp.': 'اختر غرفة واحدة على الأقل لختمها.',
  'September': 'سبتمبر',
  'Serialized Tag': 'وسم مسلسل',
  'Setup Wizard': 'معالج الإعداد',
  'Skipped': 'تم التخطي',
  'Stamp Room': 'ختم الغرفة',
  'Stamp Rooms': 'ختم الغرف',
  'Stamp {n} Room Now': 'ختم {n} غرفة الآن',
  'Stamp {n} Rooms Now': 'ختم {n} غرف الآن',
  'Stamped': 'مختوم',
  'Stamped & Verified Rooms': 'الغرف المختومة والمتحقق منها',
  'Stamped Coverage': 'تغطية الختم',
  'Stamped Rooms': 'الغرف المختومة',
  'Stamping instantiates expected draft assets from the selected blueprint, generates printable ULID QR codes, and sets up pooled inventory pars for every selected room.': 'يُنشئ الختم الأصول المسودة المتوقعة من المخطط المحدد، ويولّد رموز QR بمعرّف ULID قابلة للطباعة، ويضبط حدود المخزون المجمّع لكل غرفة محددة.',
  'Standard Bill of Materials (BOM) Requirements': 'متطلبات قائمة المواد القياسية',
  'Standardize equipment bills of materials, propagate kit diffs to stamped rooms, and monitor onboarding progress.': 'توحيد قوائم مواد المعدات، ونشر فروقات المجموعات على الغرف المختومة، ومتابعة تقدم التهيئة.',
  'Star Rating': 'تصنيف النجوم',
  'State / Region': 'الولاية / المنطقة',
  'Stock Point': 'نقطة المخزون',
  'Stock Point tag': 'وسم نقطة المخزون',
  'Store': 'مخزن',
  'Storeroom': 'مخزن',
  'Sub-Location': 'موقع فرعي',
  'Suite': 'جناح فندقي',
  'Tag {code} (new NFC tag) is now on {name}.': 'الوسم {code} (وسم NFC جديد) مربوط الآن بـ {name}.',
  'Tag {code} is now on {name}.': 'الوسم {code} مربوط الآن بـ {name}.',
  'Tag {code} was taken off and can be used again.': 'تمت إزالة الوسم {code} ويمكن استخدامه مجددًا.',
  'Tag {code} was taken off and retired.': 'تمت إزالة الوسم {code} وسحبه من الخدمة.',
  'Tags Bound': 'الوسوم المربوطة',
  'Take off': 'إزالة',
  'Take the tag off': 'إزالة الوسم',
  'Take this location out of use without losing its history': 'إخراج هذا الموقع من الاستخدام دون فقدان سجله',
  'Target Location Wing': 'الجناح المستهدف',
  'The Location Type whose kit this location takes': 'نوع الموقع الذي يأخذ هذا الموقع مجموعته',
  'The file could not be read': 'تعذّرت قراءة الملف',
  'The floor plan must be smaller than 5 MB': 'يجب أن يكون مخطط الطابق أصغر من 5 ميغابايت',
  'The kit is stamped onto locations of this type, including kitchens, stores, outlets and public areas.': 'تُختم المجموعة على مواقع هذا النوع، بما فيها المطابخ والمخازن والمنافذ والمناطق العامة.',
  'This blueprint has no items yet. Use Add BOM Item to define its bill of materials.': 'لا يحتوي هذا المخطط على بنود بعد. استخدم إضافة بند إلى قائمة المواد لتحديد قائمة مواده.',
  'This room is already stamped': 'هذه الغرفة مختومة بالفعل',
  'This {noun} is inactive, so it cannot be tagged.': '{noun} غير نشط، لذا لا يمكن وسمه.',
  'Time Zone': 'المنطقة الزمنية',
  'Total BOM Items': 'إجمالي بنود قائمة المواد',
  'Total Location Nodes': 'إجمالي عقد المواقع',
  'Total Room Capacity': 'إجمالي سعة الغرف',
  'Track physical inventory onboarding stage-by-stage across all hotel floors and wings.': 'تتبع تهيئة المخزون الفعلي مرحلة بمرحلة عبر جميع طوابق الفندق وأجنحته.',
  'Unassigned': 'غير مخصص',
  'Unique identifier used in barcode labels and stamping records': 'معرّف فريد يُستخدم في ملصقات الباركود وسجلات الختم',
  'Unrated': 'بلا تصنيف',
  'Unstamped': 'غير مختوم',
  'Updated {name} to {n} per room.': 'تم تحديث {name} إلى {n} لكل غرفة.',
  'Upload a standard CSV template containing columns:': 'ارفع قالب CSV قياسيًا يحتوي على الأعمدة:',
  'Use a 3-letter currency code (e.g. USD)': 'استخدم رمز عملة من 3 أحرف (مثل USD)',
  'Use hierarchy syntax, e.g. HTL-TOW-FL03-RM305': 'استخدم صيغة التسلسل الهرمي، مثل HTL-TOW-FL03-RM305',
  'Use letters/digits separated by hyphens, e.g. HTL-NYC-01': 'استخدم أحرفًا/أرقامًا تفصلها شرطات، مثل HTL-NYC-01',
  'Used for dates, schedules and period ends': 'يُستخدم للتواريخ والجداول ونهايات الفترات',
  'View Detail': 'عرض التفاصيل',
  'View Diff': 'عرض الفروقات',
  'View {code}': 'عرض {code}',
  'Walk {walked}/{stamped} ({pct}%)': 'الجولة {walked}/{stamped} ({pct}%)',
  'Warnings': 'التحذيرات',
  'Why is the tag coming off?': 'لماذا تتم إزالة الوسم؟',
  'Wing': 'جناح',
  'Wrong location (tag can be reused)': 'موقع خاطئ (يمكن إعادة استخدام الوسم)',
  'Zones': 'المناطق',
  'and every location beneath it leave audits, stamping and moves. Their history stays. Move or retire any assets and pooled stock held here first.': 'وكل المواقع التابعة له تخرج من الجرد والختم والنقل. يبقى سجلها محفوظًا. انقل أو استبعد أي أصول ومخزون مجمّع موجود هنا أولًا.',
  'as': 'مثل',
  'change approved across {n} room:': 'تم اعتماد التغيير على {n} غرفة:',
  'change approved across {n} rooms:': 'تم اعتماد التغيير على {n} غرف:',
  'changes to': 'على',
  'chip {uid}': 'الشريحة {uid}',
  'code(s) already exist, for example {list}.': 'رمز موجود بالفعل، مثل {list}.',
  'draft asset awaiting tag binding,': 'أصل مسودة بانتظار ربط الوسم،',
  'draft assets awaiting tag binding,': 'أصول مسودة بانتظار ربط الوسم،',
  'e.g. 32.5': 'مثال: 32.5',
  'e.g. Deluxe King': 'مثال: ديلوكس كينغ',
  'e.g. Deluxe King Kit': 'مثال: مجموعة ديلوكس كينغ',
  'e.g. HTL-AUH-02': 'مثال: HTL-AUH-02',
  'e.g. HTL-NYC-01': 'مثال: HTL-NYC-01',
  'e.g. In-Room Digital Safe': 'مثال: خزنة رقمية داخل الغرفة',
  'e.g. RM-305 or STR-3W': 'مثال: RM-305 أو STR-3W',
  'e.g. Room 305 or West Storeroom': 'مثال: الغرفة 305 أو المخزن الغربي',
  'existing type': 'نوع موجود',
  'floor(s)': 'طابق',
  'floors': 'الطوابق',
  'gives': 'ينتج',
  'is the Building or Wing code': 'هو رمز المبنى أو الجناح',
  'item removal awaiting confirmation at the next audit (for example {item} in {code}).': 'إزالة بند بانتظار التأكيد في الجرد التالي (مثل {item} في {code}).',
  'item removals awaiting confirmation at the next audit (for example {item} in {code}).': 'إزالات بنود بانتظار التأكيد في الجرد التالي (مثل {item} في {code}).',
  'line {n}:': 'السطر {n}:',
  'line(s) need fixing before anything is created.': 'سطر يحتاج إلى تصحيح قبل إنشاء أي شيء.',
  'location': 'الموقع',
  'never deleted silently': 'لا تُحذف بصمت أبدًا',
  'new': 'جديد',
  'new type': 'نوع جديد',
  'no rooms': 'بدون غرف',
  'of {n} declared rooms': 'من أصل {n} غرفة معلنة',
  'optionally followed by': 'متبوعة اختياريًا بـ',
  'or': 'أو',
  'per line. Types are matched to your Location Types by name. When the floor is left out it is read from the room number (1205 is on floor 12).': 'في كل سطر. تتم مطابقة الأنواع مع أنواع مواقعك بالاسم. وإذا لم يُذكر الطابق فإنه يُستنتج من رقم الغرفة (1205 في الطابق 12).',
  'registry': 'السجل',
  'removal pending confirmation at the next audit.': 'إزالة بانتظار التأكيد في الجرد التالي.',
  'removals pending confirmation at the next audit.': 'إزالات بانتظار التأكيد في الجرد التالي.',
  'room(s)': 'غرفة',
  'room(s) on': 'غرفة في',
  'room(s) ready': 'غرفة جاهزة',
  'rooms': 'غرفة',
  'stamped room?': 'غرفة مختومة؟',
  'stamped rooms?': 'غرف مختومة؟',
  'star': 'نجمة',
  'stars': 'نجوم',
  'to': 'إلى',
  'to attach this kit to one.': 'لربط هذه المجموعة بأحدها.',
  'under': 'تحت',
  '{assets} Assets + {pooled} Pooled': '{assets} أصول + {pooled} مجمّع',
  '{code} is back in use.': 'عاد {code} إلى الاستخدام.',
  '{code} is now inactive with {n} location(s) beneath it. Its history is kept.': 'أصبح {code} غير نشط مع {n} موقع تابع له. يبقى سجله محفوظًا.',
  '{code} is now inactive. Its history is kept.': 'أصبح {code} غير نشط. يبقى سجله محفوظًا.',
  '{done} / {total} Rooms': '{done} / {total} غرف',
  '{done} / {total} Stamped ({pct}%)': '{done} / {total} مختومة ({pct}%)',
  '{name} (Diff Review)': '{name} (مراجعة الفروقات)',
  '{name} blueprint created. Add its bill of materials next.': 'تم إنشاء المخطط {name}. أضف قائمة مواده بعد ذلك.',
  '{name} created with {n} location(s) copied': 'تم إنشاء {name} مع نسخ {n} موقع',
  '{name} is no longer attached to a Location Type.': 'لم يعد {name} مرتبطًا بنوع موقع.',
  '{name} is now the kit for {type}.': 'أصبح {name} المجموعة الخاصة بـ {type}.',
  '{name} removed from the blueprint.': 'تمت إزالة {name} من المخطط.',
  '{n} Available': '{n} متاح',
  '{n} Blueprint': '{n} مخطط',
  '{n} Blueprints': '{n} مخططات',
  '{n} Item Lines': '{n} بنود',
  '{n} Kit Changed': '{n} مجموعة تغيّرت',
  '{n} Kits Changed': '{n} مجموعات تغيّرت',
  '{n} Nodes': '{n} عقد',
  '{n} Rms': '{n} غرف',
  '{n} Rooms': '{n} غرف',
  '{n} Rooms Affected': '{n} غرف متأثرة',
  '{n} Rooms Assigned': '{n} غرف معيّنة',
  '{n} Stamped': '{n} مختومة',
  '{n} already stamped guest room': '{n} غرفة نزلاء مختومة مسبقًا',
  '{n} already stamped guest rooms': '{n} غرف نزلاء مختومة مسبقًا',
  '{n} pooled par update,': '{n} تحديث لحد المخزون المجمّع،',
  '{n} pooled par updates,': '{n} تحديثات لحد المخزون المجمّع،',
  '{n} pooled supplies per room': '{n} لوازم مجمّعة لكل غرفة',
  '{n} pooled supply per room': '{n} لوازم مجمّعة لكل غرفة',
  '{n} removal flagged for audit confirmation.': '{n} إزالة مُعلَّمة لتأكيدها في الجرد.',
  '{n} removals flagged for audit confirmation.': '{n} إزالات مُعلَّمة لتأكيدها في الجرد.',
  '{n} room stamped, {skipped} skipped.': 'تم ختم {n} غرفة، وتخطي {skipped}.',
  '{n} rooms stamped, {skipped} skipped.': 'تم ختم {n} غرف، وتخطي {skipped}.',
  '{n} standard fixed asset': '{n} أصل ثابت قياسي',
  '{n} standard fixed assets': '{n} أصول ثابتة قياسية',
  '{n} {noun} tag created and sent to print': 'تم إنشاء {n} وسم لـ {noun} وإرساله للطباعة',
  '{n} {noun} tags created and sent to print': 'تم إنشاء {n} وسوم لـ {noun} وإرسالها للطباعة',
  '{n}% Ready for Audit': '{n}% جاهزة للجرد',
  '{type} Locations': 'مواقع {type}',
  '{wings} Wings • {floors} Floors': '{wings} أجنحة • {floors} طوابق',
  '— they are marked as ‘Pending Removal’ and confirmed during the next scheduled room audit.': '— بل تُعلَّم بأنها «بانتظار الإزالة» وتُؤكَّد خلال جرد الغرفة المجدول التالي.',
};
